module.exports = __webpack_public_path__ + "img/GKW_II.1ae2a466.svg";